import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import {ObjectKeys} from '@/utilities/helpers'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {InputSelectReportByProject} from '../input-select-report-by-project/InputSelectReportByProject'
import {AttachedClinicalReportSchema} from '../../formSchemas'
import {attechedClinicalReportMapToLabel} from '../../utils'

export const AttachedClinicalReportFields = () => {
    const {t} = useTranslation()
    const form = useFormContext<AttachedClinicalReportSchema>()
    const project = useWatch({control: form.control, name: 'project'})
    const patientId = useWatch({control: form.control, name: 'project.patientId'})

    return (
        <Flexbox direction="column" gap={4}>
            {ObjectKeys(attechedClinicalReportMapToLabel).map(selectKey => (
                <Controller
                    key={selectKey}
                    control={form.control}
                    name={selectKey}
                    render={({field, fieldState}) => (
                        <InputSelectReportByProject
                            patientId={patientId}
                            projectId={project?.id}
                            label={t(attechedClinicalReportMapToLabel[selectKey])}
                            value={field.value}
                            group={selectKey}
                            placeholder={t('commons:select')}
                            errorMessage={fieldState.error?.message}
                            onChange={value => field.onChange(value)}
                        />
                    )}
                />
            ))}
        </Flexbox>
    )
}
